import { freddyTheme } from '@coolblue-development/freddy';
export const getLogoLinkStyle = () => ({
    color: freddyTheme.color.font.base,
    textDecoration: 'none',
    component: 'span',
    '&:hover': {
        color: freddyTheme.color.font.interactiveBase,
    },
});
export const getScreenReaderOnlyStyle = () => ({
    border: 0,
    clipPath: 'inset(100%)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px',
});
//# sourceMappingURL=Logo.styled.js.map